export const APP_VERSION = "jan2024"; 
export const PROJECT_TAG = "pnoistor";
export const PROJECT_NAME = "Pnoistor";
export const AUTHOR_NAME = "vaguebrownfox";
export const AUTHOR_LINK = "https://github.com/vaguebrownfox01/";
export const PROJECT_DESC = "Pnoi-phone Data Collection App";
export const PROJECT_LINK = "https://github.com/vaguebrownfox01/_pnoi-data_store";
export const GA_ID = "";
